import { useEffect, useState } from 'react'

export function CountryFlag({ code }: { code: string }) {
  const [error, setError] = useState(false)

  useEffect(() => setError(false), [code])

  if (error)
    return <i className='bi bi-flag text-secondary flex-shrink-0' style={{ width: 20 }}></i>

  return (
    <img
      src={`/flags/${code.toLowerCase()}.svg`}
      alt=''
      width={20}
      height={14}
      className='object-fit-cover rounded-1 flex-shrink-0'
      onError={() => setError(true)}
    />
  )
}
